<div id="notificacion-firma">
    <app-card Theme="card-primary shadow background-white">
        <div card-content>
            <app-body Theme="body-normal">
                <div body-content>
                    <div class="wrapper-notificacion">
                        <div class="head-notificacion">
                            <div [innerHTML]="contentNotificacion.title"></div>
                            <div class="icon-notificacion">
                                <img class="iconCheck" [src]="contentNotificacion.icon" />
                            </div>
                        </div>                         
                        <div class="body-notificacion">
                            <div>
                                <div [innerHTML]="contentNotificacion.body"></div>
                                <div class="enviar-email" *ngIf="this.CodeResult != 1 ">
                                    <form [formGroup]="formData">
                                        <div class="box-campo-input">
                                            <app-text Theme="CaptionRegular" Text="Ingresa tu email:" [RadiusLoading]="10" style="color:#0078C8;"></app-text>                                                            
                                            <input class="inputt" type="text" formControlName="email" placeholder="tuemail@domino.com" [ngClass]="{'is-invalid': submitted && f['email'].errors}" />
                                            <div class="error">
                                                <div *ngIf="submitted && f['email'].errors">
                                                    <p *ngIf="f['email'].errors['required']">
                                                        Campo obligatorio
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="btn-enviar-email">
                                            <p-button 
                                            label="Enviar" 
                                            [loading]="loading" 
                                            (onClick)="enviarEmail()"
                                            styleClass="btn-enviar" 
                                            [disabled]="loading || disabledSendEmail"
                                            />
                                
                                        </div>
                                    </form>
                                </div>
                                <div class="emailSuccess" *ngIf="emailSuccess">
                                    <p>
                                        {{labelEmailSuccess}}   
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="foo-notificacion">
                            <button tabindex="3" class="btn-submit" type="submit" (click)="descargar(contentNotificacion.context)">{{contentNotificacion.accionBtn}}</button>
                        </div>                         
                    </div>
                                                    
                </div>
            </app-body>
        </div>
    </app-card>
</div>
